const DefaultIcon = () => (
    <svg width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <polygon points="3.5,0 6.5,3.2 0.5,3.2" fill="white"/>
        <polygon points="3.5,9 6.5,5.8 0.5,5.8" fill="white"/>
    </svg>
);

const AscendingIcon = () => (
    <svg width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <polygon points="3.5,0 6.5,3.2 0.5,3.2" fill="white"/>
        <polygon points="3.5,9 6.5,5.8 0.5,5.8" fill="white" opacity="0.3"/>
    </svg>
);

const DescendingIcon = () => (
    <svg width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <polygon points="3.5,0 6.5,3.2 0.5,3.2" fill="white" opacity="0.3"/>
        <polygon points="3.5,9 6.5,5.8 0.5,5.8" fill="white"/>
    </svg>
);

export const SortButton = ({ sortOrder, ariaLabel, onClick }: { sortOrder: string, ariaLabel: string, onClick: () => void}) => {

    const icons: Record<string, JSX.Element > = {
        none: <DefaultIcon />,
        ascending: <AscendingIcon />,
        descending: <DescendingIcon />,
    };
    const icon = icons[sortOrder];

    return (
        <button 
            onClick={onClick}
            className="sortColumnBtn" 
            aria-label={ariaLabel}
            type="button"
        >
            <i aria-hidden={true}>{icon}</i>
        </button>
    );
}; 